module.exports = __webpack_public_path__ + "img/20200122125016360截图20200122124350779.795cef88.jpg";